import React, { useContext } from "react";
// import ScrollList from "charts/ScrollList";
import RosePie from "charts/RosePie";
import { DataContext } from "App";

const ShowType: React.FC = () => {
  const appData = useContext(DataContext);

  // return <ScrollList data={appData?.dimension?.play_classification_L2} />;
  return (
    <RosePie
      data={appData?.dimension?.play_classification_L2}
      hasOther={false}
      roseType="area"
      ring
    />
  );
};

export default ShowType;
